export interface CopyRegisterReserveConditionRequest {
  fromBranchCode: string
  fromUserType: string
  toBranchCode: string
  toUserTypeList: string[]
  _force: boolean
}

export function CopyRegisterReserveConditionRequestToJSON(
  value: CopyRegisterReserveConditionRequest
): any {
  return {
    from_branch_code:
      value.fromBranchCode !== '' ? value.fromBranchCode : undefined,
    from_user_type: value.fromUserType !== '' ? value.fromUserType : undefined,
    to_branch_code: value.toBranchCode !== '' ? value.toBranchCode : undefined,
    to_user_type_list:
      value.toUserTypeList.length > 0 ? value.toUserTypeList : undefined,
    _force: value._force ?? undefined
  }
}
